// extracted by mini-css-extract-plugin
export default {"button":"LiveChatButton_button__0o0I0","button__desktop":"LiveChatButton_button__desktop__Y5XF5","button__mobile":"LiveChatButton_button__mobile__qUNZQ"};